<template>
  <div class="finance-button">
    <van-button type="primary" @click="oneKeySwitch" color="linear-gradient(to right, #4bb0ff, #169bd5)" size="large">一键切换原生</van-button>
    <van-button type="primary" @click="oneKeyRollBack" color="linear-gradient(to right, #4bb0ff, #169bd5)" size="large">一键回滚</van-button>
    <p>操作注意事项：</p>
    <p>1，一键切换原生，会将当前所有三方渠道微信、支付宝交易切换微信、支付宝原生渠道</p>
    <p>2，一键回滚会恢复切换原生之前所有三方渠道路由配置</p>
  </div>
</template>

<script>
import Vue from 'vue';
import { Button, Dialog, Toast } from 'vant';
import { oneKeyRollBack, oneKeySwitch } from '../../api/finance';

Vue.use(Button).use(Dialog).use(Toast);
export default {
  methods: {
    oneKeySwitch() {
      Dialog.confirm({
        message: '确定一键切换原生？\n',
      }).then(() => {
        oneKeySwitch().then(res => {
          Toast.success('切换成功');
        }).catch(err => {
          Toast.fail(err.data || err.msgContent || '切换失败');
        });
      }).catch(() => {});
    },

    oneKeyRollBack() {
      Dialog.confirm({
        message: '确定一键回滚？\n',
      }).then(() => {
        oneKeyRollBack().then(res => {
          Toast.success('切换成功');
        }).catch(err => {
          Toast.fail(err.data || err.msgContent || '切换失败');
        });
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.finance-button {
  padding-top: calc(50vh - 300px);
  .van-button {
    width: 220px;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
    border-radius: 4px;
  }
  p {
    padding: 0 30px;
    font-size: 28px;
    line-height: 60px;
    color: #ff6c67;
  }
}

</style>
